module.exports = __webpack_public_path__ + "img/landing_en.44c9f95c.jpg";